import { Box, Button, styled } from "@mui/material";
import React from "react";
import { Check, X } from "react-feather";
import { useTranslation } from "react-i18next";

export const DialogActionsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: theme.spacing(1),
  marginTop: theme.spacing(3),

  [theme.breakpoints.down("md")]: {
    marginTop: theme.spacing(1),
  },
}));

export interface DialogActionsProps {
  onCancel: () => void;
  isSubmitting: boolean;
  isValid: boolean;
  isDeskBooking: boolean;
  isEditing: boolean;
}

export const DialogActions: React.FC<DialogActionsProps> = ({
  onCancel,
  isSubmitting,
  isValid,
  isDeskBooking,
  isEditing,
}) => {
  const { t } = useTranslation("booking");

  return (
    <DialogActionsWrapper>
      <Button
        fullWidth
        disabled={isSubmitting}
        color="cancel"
        variant="outlined"
        onClick={onCancel}
        startIcon={<X size={16} />}
        data-testid="book-form--cancel"
      >
        {t("form.action.cancel")}
      </Button>
      <Button
        fullWidth
        type="submit"
        disabled={isSubmitting || !isValid}
        color={isDeskBooking ? "primary" : "cyclamen"}
        variant="contained"
        startIcon={<Check size={16} />}
        data-testid="book-form--submit"
      >
        {isEditing ? t("form.action.edit") : t("form.action.book")}
      </Button>
    </DialogActionsWrapper>
  );
};
